module.exports = __webpack_public_path__ + "assets/images/tutorial4.7933a73.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/tutorial/tutorial4.png
// module id = 455
// module chunks = 1